import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiSearch, FiX, FiFilm, FiFileText, FiGrid } = FiIcons;

const FILTERS = [
  { id: 'all', label: 'All Content', icon: FiGrid },
  { id: 'video', label: 'Videos', icon: FiFilm },
  { id: 'news', label: 'News', icon: FiFileText }
];

const ContentFilters = ({ query, type, onQueryChange, onTypeChange }) => (
  <div className="flex flex-col gap-3">
    <div className="relative">
      <SafeIcon
        icon={FiSearch}
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-[#658d71]"
      />
      <input
        type="search"
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        placeholder="Search player, opponent, game, or headline..."
        aria-label="Search MLB news and highlights"
        className="w-full border border-[#658d71] bg-[rgba(0,0,0,0.2)] py-3 pl-10 pr-10 text-xs font-bold uppercase tracking-wider text-white placeholder:text-[#658d71] focus:border-[#d8ceb3] focus:outline-none"
      />
      {query && (
        <button
          type="button"
          onClick={() => onQueryChange('')}
          aria-label="Clear search"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#658d71] transition-colors hover:text-white"
        >
          <SafeIcon icon={FiX} size={15} />
        </button>
      )}
    </div>

    <div className="flex flex-wrap gap-2">
      {FILTERS.map((filter) => (
        <button
          type="button"
          key={filter.id}
          onClick={() => onTypeChange(filter.id)}
          className={`flex items-center gap-1.5 border px-3 py-1.5 text-[9px] font-black uppercase tracking-widest transition-colors ${
            type === filter.id
              ? 'border-[#d8ceb3] bg-[#386646] text-[#d8ceb3]'
              : 'border-[#658d71] text-[#a9c9b1] hover:border-[#a9c9b1] hover:text-white'
          }`}
        >
          <SafeIcon icon={filter.icon} size={11} />
          {filter.label}
        </button>
      ))}
    </div>
  </div>
);

export default ContentFilters;